import { render } from "./ExhibitorCard.vue?vue&type=template&id=70b24ce8&scoped=true"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js"

import "./ExhibitorCard.vue?vue&type=style&index=0&id=70b24ce8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b24ce8"]])

export default __exports__